import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RecentArtist } from '@mzic/mzic-interfaces';
import { MzicImagePipe } from '@mzic/mzic-utils';
import { MzicSvgComponent } from '../mzic-svg/mzic-svg.component';
import { SpinnerComponent } from '../spinner/spinner.component';
import { ArtistItem } from './types';

@Component({
  selector: 'mzic-search-artist-input',
  imports: [
    CommonModule,
    FormsModule,
    NgOptimizedImage,
    MzicSvgComponent,
    SpinnerComponent,
    MzicImagePipe,
  ],
  templateUrl: './search-artist-input.component.html',
  styleUrl: './search-artist-input.component.scss',
})
export class SearchArtistInputComponent {
  // Inputs
  @Input() disabledRecentList = false;
  @Input() selectedArtist: ArtistItem | null = null;
  @Input() searchResults: ArtistItem[] = [];
  @Input() isSearching = false;
  @Input() showResults = false;

  // Outputs
  @Output() artistSelected = new EventEmitter<Partial<RecentArtist>>();
  @Output() searchChanged = new EventEmitter<string>();
  @Output() clearSelection = new EventEmitter<void>();

  // Internal state
  selectArtistSearchText = '';
  photoImageArtistSelected = '';

  // Event handlers
  selectArtistSearchChanged(): void {
    this.searchChanged.emit(this.selectArtistSearchText);
  }

  selectArtist(
    artist: ArtistItem,
    isRecent: boolean,
    isSelected: boolean,
  ): void {
    this.artistSelected.emit(artist);
  }

  clearArtistSelected(): void {
    this.clearSelection.emit();
  }
}
